import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as ClassicNotificationEmailActionMetadataKeys from 'automation-ui-action-features/actions/classic-notification-email/constants/ClassicNotificationEmailActionMetadataKeys';
export default class ClassicNotificationEmailActionMetadata extends Record({
  [ClassicNotificationEmailActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_NOTIFICATION_EMAIL,
  [ClassicNotificationEmailActionMetadataKeys.EMAIL_CONTENT_ID]: null,
  [ClassicNotificationEmailActionMetadataKeys.RECIPIENT_EMAILS]: null,
  [ClassicNotificationEmailActionMetadataKeys.RECIPIENT_PROPERTY]: null
}, 'ClassicNotificationEmailActionMetadata') {
  getEmailId() {
    return this[ClassicNotificationEmailActionMetadataKeys.EMAIL_CONTENT_ID];
  }
  setEmailId(emailId) {
    return this.set(ClassicNotificationEmailActionMetadataKeys.EMAIL_CONTENT_ID, emailId);
  }
}